module.exports = __webpack_public_path__ + "img/kilometer3.a949ddb8.svg";